var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAccessibilityAccessibleAccommodation = function SvgAccessibilityAccessibleAccommodation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    vectorEffect: "non-scaling-stroke",
    viewBox: "0 0 30 30"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    vectorEffect: "non-scaling-stroke",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M1.19 26.566V14.552a2.07 2.07 0 0 1 2.056-2.056h23.508a2.07 2.07 0 0 1 2.056 2.056v12.014M3.797 12.051V5.502c0-1.137.919-2.061 2.056-2.068h18.363a2.07 2.07 0 0 1 2.056 2.057v6.56"
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M7.394 12.011V8.75a1.55 1.55 0 0 1 1.547-1.543h12.212a1.55 1.55 0 0 1 1.544 1.544v3.261M1.664 18.994H28.32M1.664 21.89H28.32m-13.312-9.502V7.206"
  }))));
};
export default SvgAccessibilityAccessibleAccommodation;